import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import styles from './QuerySuggestionsHeader.module.scss';

interface Props {
	query: string;
}

export const QuerySuggestionsHeader: React.FC<Props> = ({ query }) => {
	return (
		<div>
			<Typography className={styles.querySuggestionsHeader} variant='label1'>
				{query === '' ? 'Popular searches' : 'Search suggestions'}
			</Typography>
			<div className={`aa-SourceHeaderLine ${styles.querySuggestionsHeaderLine}`} />
		</div>
	);
};
